// SPEC-099 (RN-001, RN-002, RN-004) — punto único de escalado tipográfico fluido del
// Centro de Cotizaciones. No reintroducir fontSize literales: usar fs(basePx).
export const fs = (basePx: number): string => {
  const min = basePx * 1.2; // piso: +20% exacto (RN-001), constante en cualquier viewport
  const max = basePx * 1.38; // techo: +38%, evita crecimiento indefinido en pantallas 4K
  const slope = (max - min) / (1920 - 1024); // px de crecimiento por px de viewport, entre 1024 y 1920
  const vw = (slope * 100).toFixed(3);
  const intercept = (min - slope * 1024).toFixed(2);
  return `clamp(${min.toFixed(2)}px, ${intercept}px + ${vw}vw, ${max.toFixed(2)}px)`;
};
